/**
 * 인증수출자 번호 체계 — 문의 #125 후속(#142, 2026-10-06): EU·영국 협정 화면의 '문구 만들기' 대신.
 * EU 회원국 표: 관세청 FTA 포털 일반자료 「EU 회원국 인증수출자 번호체계 안내(2025.9.16)」 첨부
 *   '유럽연합당사자와의 자유무역협정에 따른 EU 회원국 인증수출자 번호 체계'(2025-09-16) 그대로.
 * 우리나라 번호 모양: 「자유무역협정 원산지인증수출자 운영에 관한 고시」(관세청고시 제2025-51호) 별지 제5호서식의 인증번호 칸.
 * 영국: 관세청은 브렉시트 뒤(2021.1.1) EU 번호 체계에서 영국을 뺐다고만 안내했고 영국 번호 체계는 따로 공지하지 않았다.
 */
export const KCS_BOARD_URL = "https://www.customs.go.kr/ftaportalkor/na/ntt/selectNttList.do?mi=3508&bbsId=1465";
export const AE_RULE_URL = "https://www.law.go.kr/행정규칙/자유무역협정원산지인증수출자운영에관한고시";

export const EU_AE_INTRO = "인증번호는 국가코드·세관코드·일련번호 등으로 구성됩니다. '/' 는 구분을 설명하려는 것으로, 예시에 '/' 가 있는 나라에서만 실제 번호에 씁니다.";

export const EU_AE_NUMBERS = [
  { country: "오스트리아", example: "AT/100/015", format: "국가코드(2)/세관코드(3)/인증번호(3)" },
  { country: "벨기에", example: "BE 74", format: "국가코드(2)/인증번호(1-4)" },
  { country: "불가리아", example: "BG/1223/009/08", format: "국가코드(2)/세관코드(4)/인증번호(3)/인증연도(2)" },
  { country: "사이프러스", example: "CY/NIC/000", format: "국가코드(2)/세관코드(3)/인증번호(3)" },
  { country: "크로아티아", example: "HR/10/001/13", format: "국가코드(2)/세관코드(2)/인증번호(3)/인증연도(2)" },
  { country: "체코", example: "CZ/02/0001/04, CZ/51/0001/13, CZ/10/0001/25", format: "국가코드(2)/세관코드(2)/인증번호(4)/인증연도(2)", note: "세관코드: 01-08, 51-65 또는 10, 20, 30, 40, 50, 60" },
  { country: "덴마크", example: "DK/51/04/237/00638, DK/04/000638", format: "국가코드(2)/인증기관코드(2)/인증연도(2)/인증표시코드 237 또는 239/인증번호(5) · 국가코드(2)/인증연도(2)/인증번호(6)" },
  { country: "에스토니아", example: "EE 001/2004", format: "국가코드(2)/인증번호(3)/인증연도(4)" },
  { country: "핀란드", example: "FI/50/110, FI/8/36, FI/4/2014", format: "국가코드(2)/인증번호/세관코드(3) · 국가코드(2)/인증번호/Åland 지역코드(2) · 국가코드(2)/인증번호/인증연도(4)" },
  { country: "프랑스", example: "FR 003160/0025", format: "국가코드(2)/세관코드(6)/인증번호(4)" },
  { country: "독일", example: "DE/4711/EA/0007", format: "국가코드(2)/세관코드(4)/인증수출자코드(EA)/인증번호(4)" },
  { country: "그리스", example: "GR 01/1234/2004", format: "국가코드(2)/세관코드(2)/인증번호(4)/승인연도(4)", note: "세관코드: 1-10" },
  { country: "헝가리", example: "HU123450N8000000000", format: "국가코드(2)세관코드(5)/0/level코드(N 또는 E)/인증연도(1)/인증번호(9)", note: "N: National, E: Community" },
  { country: "아일랜드", example: "IE/05/06", format: "국가코드(2)/인증번호/인증연도(2)" },
  { country: "이탈리아", example: "IT/001/RM/06, IT/002/MXP/13", format: "국가코드(2)/인증번호(3)/지역코드(2-3)/인증연도(2)", note: "Milan·Rome·Naples·Genoa·Alexandria 는 지역코드 2자리 + 숫자 1자리(세관 구분: Milan 1~3, 나머지 1~2) — 예: IT/032/M12/11, IT/033/AL1, IT/034/GE2/16. Malpensa 는 MXP 3자리" },
  { country: "라트비아", example: "LV/100/2006", format: "국가코드(2)/인증번호(1-3)/최초인증연도(4)" },
  { country: "리투아니아", example: "LT/VM0/011, LT/VM1/008", format: "국가코드(2)/세관코드(문자 2, 숫자 1)/인증번호(3)" },
  { country: "룩셈부르크", example: "LU/ORDL/256", format: "국가코드(2)/ORDL/인증번호(3)", note: "인증번호 1-500 국가인증, 501-999 단일인증" },
  { country: "몰타", example: "MT/D/000", format: "국가코드(2)/D/인증번호(3)" },
  { country: "네덜란드", example: "NL/361/02/1234", format: "국가코드(2)/세관코드(3)/인증연도(2)/인증번호(3-4)" },
  { country: "폴란드", example: "PL/042010/0001", format: "국가코드(2)/세관코드(6)/인증번호(4)" },
  { country: "포르투갈", example: "PT/000/P", format: "국가코드(2)/인증번호(3)/발급지역(P 또는 L)", note: "P: Porto, L: Lisboa" },
  { country: "루마니아", example: "RO/DRVBV/025", format: "국가코드(2)/세관코드(5)/인증번호(3)", note: "Bucharest 는 세관코드 4자리(DRVB)" },
  { country: "슬로바키아", example: "SK/1050/010/05", format: "국가코드(2)/세관코드(4)/인증번호(3)/인증연도(2)" },
  { country: "슬로베니아", example: "SI/123/03", format: "국가코드(2)/인증번호(3)/인증연도(2)" },
  { country: "스페인", example: "ES/28/0001/98, ESEAOR17000035", format: "국가코드(2)/지역코드(2)/인증번호(4)/인증연도(2) · 국가코드(2)/EAOR/인증연도(2)/인증번호(6)" },
  { country: "스웨덴", example: "SE/SHF/000001", format: "국가코드(2)/코드(3)/인증번호(6)", note: "Mö 는 코드 2자리" },
];

/** 관세청 FTA 포털 '수입 검증 — 한-EU' 의 주요 오류(원산지신고서) */
export const EU_AE_COMMON_ERRORS = [
  "인증수출자 번호가 아닌 EORI 번호·VAT 번호를 적은 경우",
  "번호 체계 안내의 예시 번호를 그대로 적은 경우",
];

/**
 * 영국 — 문의 #125 추가 질문(2026-10-06, 문의자 실무 안내). 관세청 공지·영국 정부 공개 자료에서 세부 자리 수는 확인되지 않았고,
 * 영국 공개 안내로는 번호가 국가코드 GB 로 시작한다는 것까지만 확인된다. 화면에 '실무 기준'으로 밝혀 보인다.
 */
export const GB_AE_NUMBER = { country: "영국", example: "GB 12345/21", format: "국가코드(2) 인증번호(5)/인증연도(2)" };

/** 우리나라 인증수출자 인증번호 모양(고시 별지 제5호서식) */
export const KR_AE_FORMAT = { pattern: "000-00-00000", suffix: "(차수 000)", digits: 10 };
